import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ValidationErrorResponse } from "../../common/response/ValidationErrorResponse";
import { CreateRoomMaintenanceForm } from "../schema/CreateRoomMaintenanceSchema";
import CreateRoomMaintenanceResponse from "../response/CreateRoomMaintenanceResponse";

export const useCreateRoomMaintenance = () => {
    return useMutation({
        mutationFn: async (formData: CreateRoomMaintenanceForm) => await privateApi.post(`/v4/room-maintenance`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = CreateRoomMaintenanceResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid room maintenance data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create room maintenance', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid room maintenance data format");
            } else {
                console.error(`Failed to create room maintenance`, error);
                throw error;
            }
        }
    });
};